module.exports = __webpack_public_path__ + "static/android-45b1daa59d256ebd501bf8b04a60eac8.png";